<template>
	<div v-if="metaInfoMedia && metaInfoMedia.base64Content" class="w-full h-full">
		<slot></slot>
		<div v-if="metaInfoMedia.timestamp" :class="{ 'cursor-pointer': chooseable }" class="flex" @click="triggerCheckbox">
			<div class="flex-grow">
				<div class="flex justify-between">
					<div>{{ $t('taken_input') }} {{ getDate }}</div>
				</div>
				<div class="text-left">{{ $t('time_input') }} {{ getTime }}</div>
				<div class="text-left" v-if="editable">
					{{ $t('visible_in_customer_app') }} {{ metaInfoMedia.show_customer ? $t('general.yes') : $t('general.no') }}
				</div>
			</div>
			<div class="flex">
				<font-awesome-icon
					v-if="editable"
					:class="{ 'text-blue-600': isEditMode }"
					class="text-gray-300 m-2 hover:text-blue-600"
					icon="pen"
					style="font-size: 25px"
					@click.stop="emitEdit"
				></font-awesome-icon>

				<div v-if="chooseable">
					<input v-model="isCheckboxChecked" class="hidden" type="checkbox" @change="triggerCheckbox" />
					<font-awesome-icon
						:class="{ 'text-green-300 opacity-100': isCheckboxChecked }"
						class="text-gray-300 m-2"
						icon="check"
						style="font-size: 25px"
					></font-awesome-icon>
				</div>

				<font-awesome-icon
					v-if="deletable"
					class="text-gray-300 m-2 hover:text-red-300"
					icon="trash-alt"
					style="font-size: 25px"
					@click.stop="emitDelete"
				></font-awesome-icon>
			</div>
		</div>
	</div>
</template>

<script>
import { getStringFromDate, getTimeFromDate } from '@/plugins/Utils';

export default {
	name: 'MetaInfoFile',
	props: {
		isEditMode: {
			default: false,
		},
		metaInfoMedia: {
			required: true,
		},
		alt: {
			type: String,
			default: 'MetaImage',
		},
		chooseable: {
			type: Boolean,
		},
    chooseableDefault: {
      default: false
    },
		deletable: {
			type: Boolean,
			default: true,
		},
		editable: {
			type: Boolean,
			default: false,
		},
	},
  mounted(){
    this.isCheckboxChecked = this.chooseableDefault
  },
	methods: {
		toggleCheckbox(status) {
			this.isCheckboxChecked = status;
			this.$emit('input', this.isCheckboxChecked);
		},
		triggerCheckbox() {
			this.isCheckboxChecked = !this.isCheckboxChecked;
			this.$emit('input', this.isCheckboxChecked);
		},
		emitEdit() {
			this.$emit('edit');
		},
		emitDelete() {
			this.$swal({
				title: this.$t('sure').toString(),
				text: this.$t('delete_entry').toString(),
				icon: 'warning',
				cancelButtonText: this.$t('general.no').toString(),
				showCancelButton: true,
				confirmButtonText: this.$t('general.yes').toString(),
			}).then(result => {
				if (result.value) {
					this.$emit('delete');
				}
			});
		},
	},
	data() {
		return {
			isCheckboxChecked: false,
		};
	},
	computed: {
		getDateObject() {
			if (this.metaInfoMedia.timestamp && this.metaInfoMedia.timestamp !== '-') {
				return new Date(this.metaInfoMedia.timestamp * 1000);
			} else {
				return null;
			}
		},
		getDate() {
			if (this.getDateObject) {
				return getStringFromDate(this.getDateObject);
			}
			return '-';
		},
		getTime() {
			if (this.getDateObject) {
				return getTimeFromDate(this.getDateObject);
			}
			return '-';
		},
	},
};
</script>
